{
    "brands": [
        "square-github",
        "think-peaks",
        "google-drive",
        "autoprefixer",
        "square-viadeo",
        "cpanel",
        "mendeley",
        "draft2digital",
        "replyd",
        "empire",
        "accessible-icon",
        "quora",
        "cc-jcb",
        "fedora",
        "firstdraft",
        "freebsd",
        "odysee",
        "gg-circle",
        "cloudflare",
        "hackerrank",
        "skyatlas",
        "deskpro",
        "resolving",
        "blackberry",
        "stripe-s",
        "square-behance",
        "servicestack",
        "rocketchat",
        "rebel",
        "square-web-awesome",
        "simplybuilt",
        "stubber",
        "apper",
        "google-scholar",
        "yarn",
        "stack-overflow",
        "bluetooth",
        "creative-commons-nc-jp",
        "reddit",
        "connectdevelop",
        "researchgate",
        "signal-messenger",
        "xing",
        "square-js",
        "fonticons",
        "ups",
        "amazon-pay",
        "openid",
        "ubuntu",
        "viacoin",
        "zhihu",
        "yandex",
        "pixiv",
        "sith",
        "nfc-directional",
        "creative-commons-by",
        "umbraco",
        "hooli",
        "square-git",
        "odnoklassniki",
        "drupal",
        "blogger-b",
        "invision",
        "facebook-f",
        "centos",
        "cc-amazon-pay",
        "ebay",
        "contao",
        "ello",
        "sistrix",
        "periscope",
        "expeditedssl",
        "napster",
        "delicious",
        "guilded",
        "xbox",
        "untappd",
        "google-plus-g",
        "github-alt",
        "get-pocket",
        "glide",
        "bity",
        "wpexplorer",
        "megaport",
        "mdb",
        "page4",
        "the-red-yeti",
        "jira",
        "fedex",
        "evernote",
        "usb",
        "angrycreative",
        "mizuni",
        "itch-io",
        "windows",
        "stumbleupon",
        "google",
        "discord",
        "hacker-news",
        "teamspeak",
        "supple",
        "square-twitter",
        "font-awesome",
        "wirsindhandwerk",
        "confluence",
        "digg",
        "threads",
        "wpressr",
        "yoast",
        "nimblr",
        "yahoo",
        "bluesky",
        "scribd",
        "creative-commons-pd",
        "earlybirds",
        "square-odnoklassniki",
        "markdown",
        "typo3",
        "joomla",
        "weixin",
        "grunt",
        "rockrms",
        "unsplash",
        "square-instagram",
        "first-order-alt",
        "fulcrum",
        "brave-reverse",
        "avianex",
        "ns8",
        "square-pinterest",
        "bluetooth-b",
        "gripfire",
        "square-google-plus",
        "app-store",
        "wix",
        "intercom",
        "reacteurope",
        "waze",
        "creative-commons-remix",
        "bandcamp",
        "square-web-awesome-stroke",
        "vimeo-v",
        "strava",
        "uniregistry",
        "cc-diners-club",
        "pinterest",
        "algolia",
        "stackpath",
        "octopus-deploy",
        "yammer",
        "modx",
        "square-threads",
        "old-republic",
        "suse",
        "app-store-ios",
        "square-dribbble",
        "uikit",
        "superpowers",
        "youtube",
        "ember",
        "bootstrap",
        "itunes",
        "square-xing",
        "css3-alt",
        "squarespace",
        "trello",
        "viadeo",
        "searchengin",
        "paypal",
        "square-bluesky",
        "d-and-d-beyond",
        "microsoft",
        "fly",
        "cc-stripe",
        "wordpress-simple",
        "sellsy",
        "dashcube",
        "gitter",
        "wolf-pack-battalion",
        "lastfm",
        "shopware",
        "blogger",
        "edge",
        "ioxhost",
        "schlix",
        "d-and-d",
        "vuejs",
        "meta",
        "creative-commons-share",
        "studiovinari",
        "bitbucket",
        "vk",
        "github",
        "codiepie",
        "pied-piper",
        "raspberry-pi",
        "css3",
        "hubspot",
        "cmplid",
        "dyalog",
        "elementor",
        "first-order",
        "dribbble",
        "linkedin",
        "cc-paypal",
        "dhl",
        "shopify",
        "square-reddit",
        "creative-commons-nc",
        "galactic-republic",
        "facebook",
        "gitlab",
        "qq",
        "stripe",
        "dailymotion",
        "steam",
        "snapchat",
        "galactic-senate",
        "phoenix-framework",
        "git",
        "optin-monster",
        "jenkins",
        "slideshare",
        "uber",
        "digital-ocean",
        "soundcloud",
        "creative-commons-sa",
        "chrome",
        "trade-federation",
        "vaadin",
        "deviantart",
        "medium",
        "opencart",
        "y-combinator",
        "line",
        "amilia",
        "asymmetrik",
        "phabricator",
        "bots",
        "vine",
        "medrt",
        "osi",
        "gg",
        "buysellads",
        "google-plus",
        "screenpal",
        "bitcoin",
        "swift",
        "files-pinwheel",
        "laravel",
        "wpforms",
        "speaker-deck",
        "flickr",
        "cc-visa",
        "upwork",
        "flutter",
        "buffer",
        "gratipay",
        "google-pay",
        "apple",
        "tumblr",
        "phoenix-squadron",
        "centercode",
        "debian",
        "mastodon",
        "sketch",
        "web-awesome",
        "sass",
        "square-whatsapp",
        "skype",
        "angular",
        "opensuse",
        "dropbox",
        "deezer",
        "creative-commons-sampling",
        "jedi-order",
        "r-project",
        "instalod",
        "canadian-maple-leaf",
        "ethereum",
        "houzz",
        "viber",
        "kickstarter",
        "spotify",
        "leanpub",
        "java",
        "nfc-symbol",
        "wodu",
        "square-steam",
        "creative-commons-nc-eu",
        "npm",
        "cloudscale",
        "themeco",
        "google-play",
        "korvue",
        "grav",
        "aws",
        "glide-g",
        "jsfiddle",
        "keybase",
        "weebly",
        "docker",
        "magento",
        "git-alt",
        "firefox-browser",
        "cloudsmith",
        "wizards-of-the-coast",
        "creative-commons-nd",
        "usps",
        "square-letterboxd",
        "mandalorian",
        "slack",
        "angellist",
        "android",
        "meetup",
        "fonticons-fi",
        "palfed",
        "wpbeginner",
        "diaspora",
        "product-hunt",
        "square-upwork",
        "cuttlefish",
        "medapps",
        "pix",
        "square-tumblr",
        "react",
        "jxl",
        "css",
        "hashnode",
        "reddit-alien",
        "tiktok",
        "wordpress",
        "ideal",
        "pied-piper-pp",
        "ussunnah",
        "fort-awesome-alt",
        "buromobelexperte",
        "bilibili",
        "neos",
        "dev",
        "hotjar",
        "dochub",
        "vimeo",
        "maxcdn",
        "square-font-awesome-stroke",
        "speakap",
        "fantasy-flight-games",
        "linux",
        "cotton-bureau",
        "google-wallet",
        "foursquare",
        "shirtsinbulk",
        "mintbit",
        "staylinked",
        "webflow",
        "renren",
        "rev",
        "keycdn",
        "hire-a-helper",
        "square-hacker-news",
        "creative-commons-pd-alt",
        "orcid",
        "behance",
        "monero",
        "figma",
        "instagram",
        "perbyte",
        "square-vimeo",
        "pushed",
        "mixcloud",
        "yandex-international",
        "hive",
        "creative-commons-zero",
        "square-snapchat",
        "themeisle",
        "dart-lang",
        "deploydog",
        "flipboard",
        "buy-n-large",
        "watchman-monitoring",
        "hips",
        "cloudversify",
        "goodreads",
        "unity",
        "tencent-weibo",
        "free-code-camp",
        "x-twitter",
        "sticker-mule",
        "twitch",
        "kickstarter-k",
        "critical-role",
        "steam-symbol",
        "mailchimp",
        "nutritionix",
        "creative-commons-sampling-plus",
        "redhat",
        "square-pied-piper",
        "whatsapp",
        "imdb",
        "python",
        "pinterest-p",
        "whmcs",
        "joget",
        "square-youtube",
        "atlassian",
        "pied-piper-hat",
        "internet-explorer",
        "airbnb",
        "js",
        "quinscape",
        "adversal",
        "creative-commons",
        "chromecast",
        "wikipedia-w",
        "sitrox",
        "square-gitlab",
        "shoelace",
        "sellcast",
        "mix",
        "cc-apple-pay",
        "brave",
        "etsy",
        "btc",
        "adn",
        "square-x-twitter",
        "square-font-awesome",
        "forumbee",
        "42-group",
        "stumbleupon-circle",
        "symfony",
        "salesforce",
        "sourcetree",
        "linkedin-in",
        "html5",
        "rust",
        "hornbill",
        "php",
        "500px",
        "affiliatetheme",
        "red-river",
        "twitter",
        "fort-awesome",
        "mixer",
        "lyft",
        "apple-pay",
        "artstation",
        "node-js",
        "uncharted",
        "playstation",
        "microblog",
        "gitkraken",
        "telegram",
        "itunes-note",
        "less",
        "firefox",
        "kaggle",
        "facebook-messenger",
        "audible",
        "patreon",
        "vnv",
        "pagelines",
        "amazon",
        "envira",
        "linode",
        "accusoft",
        "erlang",
        "cc-discover",
        "safari",
        "space-awesome",
        "node",
        "codepen",
        "ravelry",
        "alipay",
        "cc-amex",
        "pied-piper-alt",
        "letterboxd",
        "opera",
        "weibo",
        "readme",
        "golang",
        "stack-exchange",
        "gulp",
        "yelp",
        "gofore",
        "aviato",
        "padlet",
        "edge-legacy",
        "square-lastfm",
        "goodreads-g",
        "cc-mastercard",
        "discourse",
        "black-tie",
        "square-facebook",
        "battle-net",
        "bimobject"
    ],
    "custom-icons": [
        "vscode",
        "gitbook",
        "mcp",
        "claude",
        "gitbook-assistant",
        "chatgpt"
    ]
}
